<script>
  import Image, { asSrcset, asSrc } from '$lib/Image.svelte'
  import { autoplay } from './autoplay.js'

  export let flip = false
  export let small = false
  export let video = null

  /** @type {Prismic.ImageField<"small">?} */
  export let image = null
</script>

<div class="illustrated" class:flip class:small>
  {#if $$slots.illustration}
    <slot name="illustration" />
  {:else if video}
    <figure class="figure">
      <video
        use:autoplay
        class="video"
        playsInline
        autoPlay
        muted
        loop
        disablePictureInPicture
        width="560"
        height="560">
        <source src={video} type="video/mp4" />
      </video>
    </figure>
  {:else if image?.url}
    <div class="figure">
      {#if !image?.small?.url}
        <Image
          class="img"
          src={image.url}
          alt={image.alt || ''}
          sizes="(min-width: 900px) 40vw, 90vw"
          variants={[300, 400, 500, 600, 700, 800, 900, 1000, 1200, 1400]}
          {...image.dimensions} />
      {:else}
        <picture>
          <source
            srcset={asSrcset(
              image.url,
              [300, 400, 500, 600, 700, 800, 900, 1000, 1200, 1400]
            )}
            media="(min-width: 900px)"
            sizes="40vw" />
          <source
            srcset={asSrcset(
              image.small.url,
              [300, 400, 500, 600, 700, 800, 900, 1000, 1200, 1400]
            )}
            sizes="90vw" />
          <img
            class="img"
            {...image.dimensions}
            src={asSrc(image.url, 1200)}
            alt={image.alt} />
        </picture>
      {/if}
    </div>
  {/if}
  <div class="body">
    <slot name="body" />
  </div>
</div>

<style>
  .illustrated {
    display: grid;
    gap: 1.5rem 3rem;
    flex-flow: column wrap;
    text-wrap: balance;
  }

  .body :global(.html) {
    max-width: 33rem;
  }

  .figure {
    position: relative;
  }

  .img,
  .video {
    border-radius: var(--border-radius-lg);
    width: 100%;
  }

  @media (min-width: 600px) {
    .illustrated.small {
      grid-template-columns: min(40%, 18rem) 1fr;
      gap: 1.5rem 2rem;
      align-items: center;
    }

    .illustrated.small.flip {
      grid-template-columns: 1fr min(40%, 18rem);
    }

    .small.flip .body {
      order: -1;
    }
  }

  @media (min-width: 900px) {
    .illustrated {
      grid-template-columns: 1fr 1fr;
      align-items: center;
    }

    .illustrated.small {
      gap: 1.5rem 3rem;
    }

    .body {
      margin-top: -1rem;
      max-width: none;
    }

    .body :global(.html) {
      max-width: 45rem;
    }

    .flip .body {
      order: -1;
    }
  }

  @media (min-width: 1200px) {
    .illustrated,
    .illustrated.small {
      gap: 1.5rem 4rem;
    }
  }
</style>
